import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import http from '../http.js';
import qs from "qs";

const store = new Vuex.Store({
  state: {
    bindInfo: {
      email: "",
      cellPhone: ""
    },
    checkLeadInfo: {
      email: "",
      cellPhone: ""
    },
    checkLeadResult: {
      IsNew: false,
      ExcistLead: [],
    },
    createDisplay: false,
    bindDisplay: false,
    leadRepeatDisplay: false,
    checkDisplay: true
  },
  getters: {},
  actions: {
    saveBindInfo: function (context, bindInfo) {
      context.commit("save_BindInfo", bindInfo);
    },
    saveCheckLeadInfo: function (context, checkLeadInfo) {
      context.commit("save_checkLeadInfo", checkLeadInfo);
    },
    checkLead: function (context, source) {
      http
        .post(
          "SCRMApp/CheckLeadExistence",
          qs.stringify({
            email: source.form.email,
            phone: source.form.cellPhone,
            tutorChatToken: source.tct
          })
        )
        .then(function (response) {
          context.commit("check_Lead", response.data.Result);
          store.dispatch("setCheckDisplay", false);
          store.dispatch("setCreateDisplayByResult", response.data.Result);
          store.dispatch("setBindDisplayByResult", response.data.Result);
          store.dispatch("setLeadRepeatDisplayByResult", response.data.Result);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    setCreateDisplayByResult: function (context, checkReasult) {
      if (checkReasult.IsNew) {
        context.commit("set_CreateDisplay", true);
      } else {
        context.commit("set_CreateDisplay", false);
      }
    },
    setCreateDisplay: function (context, source) {
      context.commit("set_CreateDisplay", source);
    },
    setBindDisplayByResult: function (context, checkReasult) {
      if (!checkReasult.IsNew && checkReasult.ExcistLead != null) {
        context.commit("set_BindDisplay", true);
      } else {
        context.commit("set_BindDisplay", false);
      }
    },
    setBindDisplay: function (context, source) {
      context.commit("set_BindDisplay", source);
    },
    setLeadRepeatDisplayByResult: function (context, checkReasult) {
      if (!checkReasult.IsNew && checkReasult.ExcistLead == null) {
        context.commit("set_LeadRepeatDisplay", true);
      } else {
        context.commit("set_LeadRepeatDisplay", false);
      }
    },
    setLeadRepeatDisplay: function (context, source) {
      context.commit("set_LeadRepeatDisplay", source);
    },
    setCheckDisplay: function (context, source) {
      context.commit("set_CheckDisplay", source);
    },
    setDisplayToDefult: function (context) {
      context.commit("set_DisplayToDefult");
    },
  },
  mutations: {
    save_BindInfo: function (state, bindInfo) {
      state.bindInfo = bindInfo;
    },
    save_checkLeadInfo: function (state, checkLeadInfo) {
      state.checkLeadInfo = checkLeadInfo;
    },
    check_Lead: function (state, checkLeadResult) {
      state.checkLeadResult = checkLeadResult;
    },
    set_CreateDisplay: function (state, createDisplay) {
      state.createDisplay = createDisplay;
    },
    set_BindDisplay: function (state, bindDisplay) {
      state.bindDisplay = bindDisplay;
    },
    set_LeadRepeatDisplay: function (state, leadRepeatDisplay) {
      state.leadRepeatDisplay = leadRepeatDisplay;
    },
    set_CheckDisplay: function (state, checkDisplay) {
      state.checkDisplay = checkDisplay;
    },
    set_DisplayToDefult: function (state) {
      state.createDisplay = false;
      state.bindDisplay = false;
      state.leadRepeatDisplay = false;
      state.checkDisplay = true;
    },
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/vuex/store_lead.js